module.exports = __webpack_public_path__ + "static/media/background2.b92aa42e.png";